<div class="site-text">
    <p class="text">
        eDirectory.ch fa parte delle attività di swissDIGIN ed è gestito da PostFinance SA. L’esercizio tecnico viene svolto per conto di PostFinance SA dalla ditta xeFex SA.
    </p>
    <p class="title">
        swissDIGIN
    </p>
    <p class="text">
        L’iniziativa swissDIGIN (swiss Digital Invoice) promuove lo scambio elettronico di fatture tra aziende e organizzazioni (in breve: e-invoicing) in Svizzera. A tal fine, swissDIGIN mette a disposizione delle aziende un know-how di stampo neutrale.
        <br>
        <a href="https://www.swissdigin.ch" target="_blank">www.swissdigin.ch</a>
    </p>
    <p class="title">
        PostFinance SA
    </p>
    <p class="text">
        In qualità di leader del mercato nel settore della fatturazione elettronica in Svizzera, da oltre 20 anni PostFinance digitalizza l’emissione e la ricezione delle fatture dei suoi clienti.
        PostFinance funge da fornitore di servizi di e-invoicing, partner di rete di eBill e banca collegata a eBill. Con la soluzione di PostFinance, aziende e organizzazioni possono scambiare e-fatture con partner commerciali oltre a inviare e ricevere eBill, rendendo così i propri processi più efficienti. I clienti commerciali beneficiano di una consulenza a 360° e hanno a disposizione una persona di contatto che si occupa di tutte le questioni relative all’e-invoicing.
        <br>
        <a href="https://www.postfinance.ch/billing-solutions" target="_blank">www.postfinance.ch/billing-solutions</a>
    </p>
    <p class="title">
        xeFex SA
    </p>
    <p class="text">
        xeFex SA fornisce servizi IT nei settori della programmazione, consulenza e direzione di progetto.
        <br>
        <a href="https://www.xefex.ch" target="_blank">www.xefex.ch</a>
    </p>
    <p class="title">
        xeFex SA fornisce servizi IT nei settori della programmazione, consulenza e direzione di progetto.
    </p>
    <p class="text">
        I seguenti fornitori di servizi di e-invoicing tengono un elenco degli emittenti e dei destinatari di fatture collegati alla loro rete e interessati a sfruttare maggiormente tali servizi su eDirectory.ch.
    </p>
    <a class="logo" href="https://www.postfinance.ch/billing-solutions" target="_blank"><img src="/assets/images/post_finance.png" alt="postfinance logo"></a>
    <a class="logo" href="https://www.abacus.ch" target="_blank"><img src="/assets/images/abacus_full.png" alt="abacus logo"></a>
    <p class="text">
        Se in qualità di service provider offrite servizi di e-invoicing ad aziende e organizzazioni domiciliate in Svizzera e desiderate pubblicare i vostri clienti su eDirectory, comunicatelo a PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Vi contatteremo al più presto.
    </p>
</div>
